var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-main',[_c('v-container',{attrs:{"tag":"section"}},[_c('h3',{staticClass:"mb-2 text-center text-h3"},[_vm._v(_vm._s(_vm.$t('nav.about.editorial-college')))]),_c('staff-list',{attrs:{"entries":_vm.editorialCollege}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }